import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : '.checkbox-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Check Box</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm" novalidate>
        <check-box [(ngModel)]="model.required"
                   name="required"
                   label="Is Required"
                   labelPlacement="after"></check-box>
        <check-box [(ngModel)]="model.isThreeState"
                   name="threeState"
                   label="Is Three State"
                   labelPlacement="after"></check-box>
        <check-box
                [name]="model.name"
                [required]="model.required"
                [threeState]="model.isThreeState"
                [checkedValue]="model.value"
                [(ngModel)]="model.ngModel"
                [(state)]="model.state"
                label="Test Check Box">
        </check-box>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class CheckBoxDemoComponent {

    model = {
        ngModel     : null,
        name        : 'testCheckBox',
        isThreeState: false,
        required    : true,
        state       : 'off',
        value       : 'CHECK BOX IS CHECKED!'
    };

    markup = `
<check-box
    [name]="model.name"
    [required]="model.required"
    [threeState]="model.isThreeState"
    [checkedValue]="model.value"
    [(ngModel)]="model.ngModel"
    [(state)]="model.state"
    label="Test Check Box"></check-box>
    `;
}


